module.exports = __webpack_public_path__ + "static/img/02.7e38d2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/jzjy/02.png
// module id = Dl/p
// module chunks = 0